import React from 'react';
import Row from 'src/components/10-atoms/layout/Row';
import Typography from 'src/components/10-atoms/typography/Typography';
import { TypographyVariant } from 'src/customizations/themes/10-parts/typography';
import useTheme from 'src/customizations/themes/hooks/useTheme';
import { listPageCount, pageNoFromOffset, parseLimit, parseOffset, } from 'src/utils/pagination/listPagination';
import TextButton from '../button/TextButton';
import { PRESSABLE_SIZE } from '../pressables/constants';
const PaginationNav = ({ offset, limit, totalCount, hasMore, buildPageTo, }) => {
    const [{ theme }] = useTheme();
    const currentOffset = parseOffset(offset);
    const pageLimit = parseLimit(limit);
    const currentPage = pageNoFromOffset(currentOffset, pageLimit);
    const totalPages = listPageCount(totalCount, pageLimit);
    const showPrev = currentOffset > 0;
    const showNext = hasMore;
    const prevOffset = Math.max(0, currentOffset - pageLimit);
    const nextOffset = currentOffset + pageLimit;
    return (React.createElement(Row, { spacing: theme.spacing.standard.sm, ph: theme.spacing.page, pv: theme.spacing.standard.md, brd: PRESSABLE_SIZE, mh: theme.spacing.standard.sm, mv: theme.spacing.standard.md, bwd: 1, bg: theme.palette.background.main, yAxis: "center", xAxis: "space-between", wrap: true },
        React.createElement(Row, { xAxis: 'flex-start', flex: true }, showPrev && (React.createElement(TextButton, { to: buildPageTo(prevOffset) }, "Prev"))),
        React.createElement(Row, { xAxis: 'center', flex: true },
            React.createElement(Typography, { variant: TypographyVariant.BODY, color: theme.palette.typography.secondary },
                "Page ",
                currentPage,
                " of ",
                totalPages)),
        showNext ? (React.createElement(Row, { xAxis: 'flex-end', flex: true },
            React.createElement(TextButton, { to: buildPageTo(nextOffset) }, "Next"))) : React.createElement(Row, { flex: true })));
};
export default PaginationNav;
